export const MORE_THAN_THREE_FACILITIES =
  'Existe más de tres instalaciones activas en el pozo. Confirmá los tipos de instalaciones vigentes que correspondan para este Handover';
export const SAME_TYPE_FACILITIES =
  'Existe más de una instalación del mismo tipo. Confirmá los tipos de instalaciones vigentes que correspondan para este Handover.';
export const MORE_THAN_ONE_AND_SAME_TYPE_FACILITIES =
  'Existen más de tres instalaciones activas en el pozo y más de una instalación del mismo tipo. Confirmá los tipos de instalaciones vigentes que correspondan para este Handover';
